import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          <img src="/logo.jpg" alt="Blue Point Logo" className="nav-logo-img" />
          <span className="nav-logo-text">The BluePoint Org</span>
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isOpen ? 'hamburger active' : 'hamburger'}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li
            className="nav-item dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <span className="nav-link">
              What We Do ▾
            </span>
            <ul className={dropdownOpen ? 'dropdown-menu active' : 'dropdown-menu'}>
              <li>
                <Link to="/youth-training" className="dropdown-link" onClick={closeMenu}>
                  Adolescent & Youth Training
                </Link>
              </li>
              <li>
                <Link to="/hr-development" className="dropdown-link" onClick={closeMenu}>
                  HR & Organization Development
                </Link>
              </li>
              <li>
                <Link to="/communication" className="dropdown-link" onClick={closeMenu}>
                  Creative Communication
                </Link>
              </li>
              <li>
                <Link to="/research" className="dropdown-link" onClick={closeMenu}>
                  Research & Consulting
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item">
            <Link to="/gallery" className="nav-link" onClick={closeMenu}>
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/get-involved" className="nav-link" onClick={closeMenu}>
              Get Involved
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
